import React, { useEffect, useRef, useState } from "react";
import { Armchair, Loader, X } from "lucide-react";
import DatePicker from "react-datepicker";
import Select from "react-select";
import { formatDate, getDateString, notify } from "../../helpers";
import Spacing from "../Spacing";
import { Drawer } from 'vaul';
import { createBulkWaingList } from "../../services/waitingRoom";

const customSelectStyles = {
  control: (base, state) => ({
    ...base,
    border: "1px solid #D1D5DB",
    minHeight: '40px',
    borderRadius: '8px',
    boxShadow: state.isFocused ? "0 0 0 .5px var(--accent)" : "none",
    "&:hover": {
      borderColor: "#9CA3AF",
    },
  }),
  placeholder: (base) => ({
    ...base,
    fontSize: "0.875rem",
    color: "#9CA3AF",
    fontWeight: "normal",
  }),
  option: (base) => ({ ...base, cursor: "pointer" }),
  menuPortal: (base) => ({ ...base, zIndex: 999999 }),
  menu: (base) => ({
    ...base,
    marginTop: '-1px',
    border: "1px solid #D1D5DB",
    borderRadius: "0 0 0.375rem 0.375rem",
    zIndex: 999999,
  }),
};

export default function BulkWaitingRoomAddModal({
  account_id,
  location_id,
  activeModal = false,
  setActiveModal = () => {},
  previousScrollPosition = 0,
  checkedIds = [],
  userProviders = [],
  specilityId,
}) {
  let dateStr = getDateString();
  const dropdownRef = useRef(null);
  const [startDate, setStartDate] = useState(dateStr);
  const [selectedProvider, setSelectedProvider] = useState(null);
  const [checkedClaimLoader, setCheckedClaimLoader] = useState(false);

  const allProviders = userProviders?.map((option) => ({
    value: option?.provider_id,
    label: `${option?.first_name} ${option?.last_name}`,
  }));

  useEffect(() => {
    if (typeof window === "undefined") return;
    let el = document.getElementById("docpro-datepicker-portal");
    if (!el) {
      el = document.createElement("div");
      el.id = "docpro-datepicker-portal";
      document.body.appendChild(el);
    }
  }, []);

  const handleConfirmAppointment = async() => {
    const postData = {
      account_id: account_id,
      location_id: location_id,
      speciality_id: specilityId,
      dos: formatDate(startDate),
      provider_id: selectedProvider,
      patient_ids: checkedIds,
    };

    setCheckedClaimLoader(true);
    try {
      const response = await createBulkWaingList(postData);
      if(response){
        if(response?.detail) {
          notify("error", response?.detail);
        } else {
          if(response?.data?.status === "success"){
            notify("success", response?.data?.message, 5);
            handleDrawerClose();
          } else {
            notify("error", response?.data?.message, 5);
          }
        }
      }
    } catch (error) {
      if (error?.response && error?.response?.data && error?.response?.data?.detail) {
        notify("error", error?.response?.data?.detail);
      }
    } finally {
      setCheckedClaimLoader(false);
    }
  };

  const isDisabled = checkedClaimLoader || (!startDate && !selectedProvider);

  const handleDrawerClose = () => {
    setActiveModal(false);
    window.scrollTo(0, previousScrollPosition);
  };

  return (
    <div style={{ height: "100%" }} ref={dropdownRef}>
      <Drawer.Root open={activeModal} onOpenChange={handleDrawerClose}>
        <Drawer.Trigger className="docpro_single_patiant_modal_btn">
        </Drawer.Trigger>
        <Drawer.Portal>
          <Drawer.Overlay className="docpro_drawer_overlay"/>
          <Drawer.Content className="docpro_drawer_content docpro_drawer_style_4 medium">
            <Drawer.Title className="sr-only">Add to Waiting Room</Drawer.Title>
            <Drawer.Description className="sr-only">Add Patients on Waiting Room</Drawer.Description>
            <div className="docpro_modal_wrap docpro_style_2 docpro_style_auto">
              <div className="docpro_modal">
                <div className="modal_height_100">
                  <div>
                    <button
                      className="docpro_close_btn"
                      onClick={handleDrawerClose}
                    >
                      <X />
                    </button>
                    <h2 className="docpro_fs_24 docpro_mb_0">Add Waiting Room</h2>
                    <Spacing lg="20" sm="20" />
                    <label className="docpro_fw_500 docpro_primary_color">
                      DOS
                    </label>
                    <DatePicker
                      selected={startDate}
                      onChange={(d) => setStartDate(d)}
                      className="size_lg"
                      placeholderText='mm/dd/yyyy'
                      popperProps={{ strategy: "fixed" }}
                      popperClassName="docpro_datepicker_popper"
                    />
                    <Spacing lg="20" sm="20" />
                    <label className="docpro_fw_500 docpro_primary_color">
                      Provider
                    </label>
                    <Select
                      required
                      options={allProviders}
                      onChange={(selectedOption) => setSelectedProvider(selectedOption?.value)}
                      placeholder="Select time of day..."
                      isSearchable={true}
                      value={allProviders?.find((option) => option?.value === selectedProvider) || null}
                      className="react-select-container w-full"
                      classNamePrefix="react-select"
                      styles={customSelectStyles}
                    />
                    <Spacing lg="20" sm="20" />
                  </div>
                  <button
                    className="docpro_bordered_btn docpro_fw_600 docpro_white_color docpro_filed_btn docpro_mt_auto"
                    style={{ width: "100%", padding: "10px 12px" }}
                    onClick={handleConfirmAppointment}
                    disabled = {isDisabled}
                  >
                    <Armchair width={20} height={20} />
                    <span>Add to Waitning Room</span>
                    {checkedClaimLoader && (
                      <span className="docpro_loading">
                        <Loader width={20} height={20} />
                      </span>
                    )}
                  </button>
                </div>
              </div>
            </div>
          </Drawer.Content>
        </Drawer.Portal>
      </Drawer.Root>
    </div>
  );
}
